/**
 * AVS-4477: normalizes an integrator-provided Showroom config-id (`E3D.init({ showroomConfigId })`).
 *
 * Returns the ORIGINAL, untrimmed string when it has non-whitespace content, and `''` for anything
 * else (undefined, null, non-strings, empty or whitespace-only strings). `''` means "no override".
 * The id is never validated: unknown ids pass through unchanged.
 *
 * Lives in its own module (not `showroom.ts`) so that tests mocking `utils/ui/showroom` don't
 * lose it when `runtime.ts` imports it.
 */
export function normalizeShowroomConfigId(value: unknown): string {
  return typeof value === 'string' && value.trim() !== '' ? value : '';
}
